import { useContext } from "react";
import { WellContext } from "../context/WellContext";



/* ✅ Reusable SHUTDOWN Valve Component */

    import { useState } from "react";

    

function Valve({
  tag,
  x,
  y,
  isClosed,
  toggle,
  r = 0,
  scale = 1
}) {
  const [hover, setHover] = useState(false);

  return (
    <svg
      width="35"
      height="42"
      viewBox="0 0 220 220"
      style={{
        position: "absolute",
        left: x,
        top: y,
        cursor: "pointer",
        transform: `rotate(${r}deg) scale(${scale})`,
        transition: "0.5s ease",
        filter: hover
  ? isClosed
    ? "drop-shadow(0 0 6px lime)"
    : "drop-shadow(0 0 6px red)"
  : "none",
  transform: hover
  ? `rotate(${r}deg) scale(${scale * 1.05})`
  : `rotate(${r}deg) scale(${scale})`,
      }}
      onClick={() => toggle(tag)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <g>
        <rect
          x="0"
          y="0"
          width="220"
          height="80"
          stroke="black"
          strokeWidth="2"
          fill={isClosed ? "red" : "lime"}
        />

        <rect
          x="107"
          y="80"
          width="15"
          height="60"
          stroke="black"
          strokeWidth="2"
          fill={isClosed ? "red" : "lime"}
        />

        <polygon
          points="0,210 110,140 0,100"
          stroke="black"
          strokeWidth="2"
          fill={isClosed ? "red" : "lime"}
        />

        <polygon
          points="220,210 110,140 220,100"
          stroke="black"
          strokeWidth="2"
          fill={isClosed ? "red" : "lime"}
        />
      </g>
      
    </svg>
  );
}


export default Valve;